import { FC } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import DropdownMenuItem from 'src/components/ui/atoms/DropdownMenuItem'
import SettingsAdminIcon from 'src/components/ui/atoms/Icons/SettingsAdminIcon'

const LINK = '/account/platform'

const MySettingsMenu: FC = () => {
  const { pathname } = useLocation()
  const isActive = pathname === LINK

  return (
    <NavLink to={LINK}>
      <DropdownMenuItem
        icon={<SettingsAdminIcon />}
        label="My Settings"
        data-testid="header-settings-menu-my-settings"
        active={isActive}
        classes={{
          icon: 'text-hit-gray',
          activeIcon: 'text-inherit',
        }}
      />
    </NavLink>
  )
}

export default MySettingsMenu
